/**
 * API Configuration utilities
 * Centralizes API URL management and provides helper functions for API calls
 */

// Get the appropriate API URL based on authentication status
export const getApiUrl = (authenticated: boolean = false): string => {
    if (authenticated) {
        const url = process.env.REACT_APP_AUTHORIZED_API_URL;
        if (!url) {
            const fallback = process.env.REACT_APP_API_URL || 'https://api.famousinitials.com';
            console.warn('AUTHORIZED_API_URL not set, using fallback:', fallback);
            return fallback;
        }
        return url;
    } else {
        const url = process.env.REACT_APP_API_URL;
        if (!url) {
            const fallback = 'https://api.famousinitials.com';
            console.warn('PUBLIC_API_URL not set, using fallback:', fallback);
            return fallback;
        }
        return url;
    }
};

// Build full API endpoint URL
export const buildApiEndpoint = (endpoint: string, authenticated: boolean = false): string => {
    const baseUrl = getApiUrl(authenticated);
    // Ensure endpoint starts with /
    const cleanEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
    return `${baseUrl}${cleanEndpoint}`;
};

// API configuration object for easy access
export const API_CONFIG = {
    // Get base URLs
    getBaseUrl: getApiUrl,
    getAuthorizedBaseUrl: () => getApiUrl(true),
    getPublicBaseUrl: () => getApiUrl(false),
    
    // Common endpoints
    endpoints: {
        games: '/games/',
        data: '/data/',
        // Add more endpoints here as needed
    },
    
    // Build full URLs for endpoints
    buildUrl: buildApiEndpoint,
    
    // Helper for games endpoint specifically
    getGamesUrl: (authenticated: boolean = false) => buildApiEndpoint('/games', authenticated),
    
    // Helper for data endpoint specifically  
    getDataUrl: (authenticated: boolean = false) => buildApiEndpoint('/data', authenticated),
};

export default API_CONFIG;
